import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class MoveImageAction extends AbstractProvidedClass {
    isImageAction = true;
    movedX = 0;
    movedY = 0;

    constructor(provider) {
        super(provider);
        this.lastMouseAbsX = (this.p.mouseX - this.view.posX) / this.view.scale;
        this.lastMouseAbsY = (this.p.mouseY - this.view.posY) / this.view.scale;
    }

    update() {
        let mouseAbsX = (this.p.mouseX - this.view.posX) / this.view.scale;
        let mouseAbsY = (this.p.mouseY - this.view.posY) / this.view.scale;
        let moveX = mouseAbsX - this.lastMouseAbsX;
        let moveY = mouseAbsY - this.lastMouseAbsY;
        this.lastMouseAbsX = mouseAbsX;
        this.lastMouseAbsY = mouseAbsY;

        if (moveX != 0 || moveY != 0) {
            this.movedX += moveX;
            this.movedY += moveY;
            this.image.move(moveX, moveY);
        }
    }

    finish() {
        this.actions.finish();
    }

    undo() {
        this.image.move(-this.movedX, -this.movedY);
    }

    redo() {
        this.image.move(this.movedX, this.movedY);
    }
}
